import React from 'react';
import { useCheckUserGroupsAccess } from '../../hooks/useCheckUserGroupsAccess';
import { UserGroup } from '@round/api';
import { FCWithChildren } from '../../../../App.types';

type ProtectedByUserGroupsProps = {
    groups: UserGroup[];
    hasAccessWhenMatches?: 'all' | 'any';
};

export const ProtectedByUserGroups: FCWithChildren<ProtectedByUserGroupsProps> = ({
    children,
    groups,
    hasAccessWhenMatches = 'all',
}) => {
    const canAccess = useCheckUserGroupsAccess(groups, hasAccessWhenMatches);
    if (!canAccess) {
        return null;
    }

    return <>{children}</>;
};
